import { useEffect, useMemo, useState } from "react";
import { soulManager } from "../../data/managers/SoulManager";
import { PaymentDataModel } from "../../data/models/Soul/PaymentDataModel";

export function useAdminPayments() {
  const [payments, setPayments] = useState<PaymentDataModel[]>([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const fetchPayments = async () => {
    setLoading(true);
    try {
      const res = await soulManager.getAllPayments();
      setPayments(res ?? []);
    } catch (e) {
      console.error("❌ Error cargando pagos:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayments();
  }, []);

  const filtered = useMemo(() => {
    const lower = search.toLowerCase();
    return payments.filter(
      (u) =>
        u.soul?.email?.toLowerCase().includes(lower) ||
        u.status?.toLowerCase().includes(lower) ||
        u.stripeSessionId?.toLowerCase().includes(lower)
    );
  }, [payments, search]);

  const handleExportCSV = () => {
    const csvRows = [
      [
        "Stripe Session",
        "Correo",
        "Estado",
        "Plan",
        "Monto ($)",
        "Creado",
        "Actualizado",
      ],
      ...payments.map((p) => [
        p.stripeSessionId ?? "",
        p.soul?.email ?? "",
        p.status ?? "",
        p.plan?.name ?? "",
        p.amountUsd?.toString() ?? "",
        p.createdAt ? new Date(p.createdAt).toISOString() : "",
        p.updatedAt ? new Date(p.updatedAt).toISOString() : "",
      ]),
    ];

    const csvString = csvRows.map((row) => row.join(",")).join("\n");

    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "pagos.csv";
    a.click();

    URL.revokeObjectURL(url);
  };

  return {
    payments: filtered,
    loading,
    search,
    setSearch,
    handleExportCSV,
  };
}
